import React, { lazy, useEffect } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { ErrorBoundarySuspense } from '../../../../common/ui/error-boundary-suspense';
import { triggerFailedToRetrieveNotificationsEvent, useCreateFireAnalyticsFromTrigger } from '../../../../common/utils/analytics';
import messages from '../../../../common/utils/i18n/messages';
import { CenterLayout, Heading, LargeSVGContainer, MediumSVGContainer, Text } from './styled';
var GenericError = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_notification-list/GenericError" */
  '../../../../common/ui/generic-error');
});
export var TotalFailure = function TotalFailure(_ref) {
  var notificationsRendered = _ref.notificationsRendered;
  var fireFailedToRetrieveNotificationsEvent = useCreateFireAnalyticsFromTrigger(triggerFailedToRetrieveNotificationsEvent);
  useEffect(function () {
    fireFailedToRetrieveNotificationsEvent(notificationsRendered);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(CenterLayout, null, notificationsRendered > 0 ? /*#__PURE__*/React.createElement(MediumSVGContainer, null, /*#__PURE__*/React.createElement(ErrorBoundarySuspense, {
    loadingFallback: /*#__PURE__*/React.createElement("svg", null),
    errorFallback: /*#__PURE__*/React.createElement("svg", null),
    subjectId: "genericError"
  }, /*#__PURE__*/React.createElement(GenericError, null))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LargeSVGContainer, null, /*#__PURE__*/React.createElement(ErrorBoundarySuspense, {
    loadingFallback: /*#__PURE__*/React.createElement("svg", null),
    errorFallback: /*#__PURE__*/React.createElement("svg", null),
    subjectId: "genericError"
  }, /*#__PURE__*/React.createElement(GenericError, null)))), /*#__PURE__*/React.createElement(Heading, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.notificationsLoadingErrorTitle)), /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.notificationsLoadingErrorDescription)));
};